import React from 'react';
import SurveySettingsContextProvider from './context/SurveySettingsContext';
import SurveyContainer from './components/SurveyContainer';

const Survey = (): JSX.Element => {
  return (
    <SurveySettingsContextProvider>
      <SurveyContainer />
    </SurveySettingsContextProvider>
  );
};

export default Survey;
